import React from "react";

const Solution = ({ solution }) => (
  <article className="solutions__solution-item">
    <div className="solutions__solution-header">
      <a href={solution.detailPageLink}>{solution.title}</a>
    </div>
    <p className="solutions__solution-description">{solution.overviewText}</p>
  </article>
);

export default Solution;
